import { isSafePostLoginRedirect } from "./isSafePostLoginRedirect";

type ResolvePostLoginRedirectParams = {
  locationSearch?: null | string;
  preAuthenticatedPath?: null | string;
  routeAfterLoginParam?: null | string;
};

const getNormalizedRedirectPath = (
  redirectPath?: null | string
): null | string => {
  if (!redirectPath) {
    return null;
  }

  const trimmedRedirectPath = redirectPath.trim();
  if (!trimmedRedirectPath) {
    return null;
  }

  return isSafePostLoginRedirect(trimmedRedirectPath)
    ? trimmedRedirectPath
    : null;
};

const getRouteAfterLoginFromSearch = (
  locationSearch?: null | string
): null | string => {
  if (!locationSearch) {
    return null;
  }

  const queryParams = new URLSearchParams(locationSearch);
  return getNormalizedRedirectPath(queryParams.get("routeAfterLogin"));
};

export const getRouteAfterLoginFromUrl = (
  url?: null | string
): null | string => {
  if (!url) {
    return null;
  }

  try {
    return getRouteAfterLoginFromSearch(new URL(url).search);
  } catch (_error) {
    return null;
  }
};

export const resolvePostLoginRedirect = ({
  locationSearch,
  preAuthenticatedPath,
  routeAfterLoginParam,
}: ResolvePostLoginRedirectParams): null | string => {
  return (
    getNormalizedRedirectPath(routeAfterLoginParam) ??
    getRouteAfterLoginFromSearch(locationSearch) ??
    getNormalizedRedirectPath(preAuthenticatedPath)
  );
};
